(() => {
  const PREORDER_TEXT = 'Pre-Order';

  function enforcePreorder(root = document) {
    root.querySelectorAll('button[data-preorder="true"]').forEach((btn) => {
      // Don't override sold out / unavailable states (they disable the button)
      if (btn.hasAttribute('disabled')) return;

      const span = btn.querySelector('span');
      if (!span) return;

      if (span.textContent.trim() !== PREORDER_TEXT) {
        span.textContent = PREORDER_TEXT;
      }
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', () => enforcePreorder());

  // Run when options change (covers radios/selects)
  document.addEventListener('change', (e) => {
    if (
      e.target.closest('variant-radios') ||
      e.target.closest('variant-selects') ||
      e.target.closest('.product-form')
    ) {
      enforcePreorder(e.target.closest('product-info') || document);
    }
  });

  // Watch for Dawn rewriting the span text after variant updates
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList' || m.type === 'characterData') {
        const node = m.target.nodeType === 3 ? m.target.parentElement : m.target; // text node -> parent
        const btn = node && node.closest ? node.closest('button[data-preorder="true"]') : null;
        if (btn) enforcePreorder(btn.closest('product-info') || document);
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  });

  // Theme editor reloads sections dynamically
  document.addEventListener('shopify:section:load', () => enforcePreorder());
})();
